import React from 'react';
import styled, { useTheme } from 'styled-components';

import { Theme } from '../../../core';
import LoadingLogoFile from '../../images/loading-logo.gif';
import LoadingLogoNew from '../../images/loading-logo-v2.gif';

export interface LoadingLogoProps {
  className?: string;
}

const Overlay = styled.div`
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

const Image = styled.img`
  width: 81px;
`;

const LoadingLogo = ({ className }: LoadingLogoProps) => {
  const theme = useTheme();

  if (theme.name === Theme.theme3) {
    return (
      <Overlay className={className}>
        <Image src={LoadingLogoNew} alt="" />
      </Overlay>
    );
  }

  return (
    <Overlay className={className}>
      <Image src={LoadingLogoFile} alt="" />
    </Overlay>
  );
};

export default LoadingLogo;
